import React, { Component, Fragment } from 'react'
import Logout from '../../redux/actions/Logout';
import { connect } from 'react-redux';
import dateFormatIndo from '../../utils/helpers/dateFormatIndo';

class KcHeader extends Component {
    render() {
       const {notif, status, profile} = this.props;
        return (
            <nav className="main-header navbar navbar-expand">
                <ul className="navbar-nav">
                    <li className="nav-item">
                    <a className="nav-link" data-widget="pushmenu" href="/#"><i className="fas fa-bars"></i></a>
                    </li>
                </ul>
                
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item dropdown">
                        <a className="nav-link" data-toggle="dropdown" href="/#">
                            <i className="far fa-bell"></i>
                            {
                                ((!notif.isLoading || !status.loading) && notif.list.filter(e => !e.readStatus).length > 0) && 
                                <span className="badge">{notif.list.filter(e => !e.readStatus).length}</span> 
                            }
                        </a>
        
                        <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right notification-header">
							<span className="dropdown-item dropdown-header text-left">Notifikasi</span>
                            <div className="dropdown-divider"></div>

                            {
                                notif.list.slice(0,3).map((data, index) => {
                                    return (
                                        <div className='notif-list' key={index}>
                                            <a href='/#' onClick={e => {e.preventDefault(); this.props.setReadNotif(data.id, data.readStatus)}} className="dropdown-item">
                                                <p>{data.subject}</p>
                                                <span><i className="far fa-clock"></i> {dateFormatIndo(data.createdAt, 'long', ' ', 'hm')}</span>
                                            </a>
                                            <div className="dropdown-divider"></div>

                                            {(!data.readStatus) && <div className='icon-read'></div>}
                                        </div>
                                    )
                                })
                            }
        
                            <a href="/notifikasi" className="dropdown-item dropdown-footer">Lihat Semua notifikasi</a>
                        </div>
                    </li>
                    <li className="nav-item dropdown">
                        <a className="nav-link" data-toggle="dropdown" href="/#">
                            <i className="icon-user far fa-user"></i>
                        </a>
                        
                        <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
							<span className="dropdown-item dropdown-header text-left">Hai, {(profile.list) ? (profile.list.picDetail.fullName) ? profile.list.picDetail.fullName : 'Calon Peminjam' : 'Calon Peminjam'}...</span>
							<div className="dropdown-divider"></div>

                            <a href="/ubah-password" className="dropdown-item">
                                <i className="fas fa-key fa-fw mr-2"></i> Ubah Kata Sandi
                            </a>
                            <div className="dropdown-divider"></div>
                            <a href='/#' onClick={(e) => {e.preventDefault(); Logout();}} className="dropdown-item">
                                <i className="fas fa-sign-out-alt fa-fw mr-2"></i> Keluar
                            </a>
                        </div>
                    </li>
                </ul>
            </nav>  
        )
    }
}

export default KcHeader;